// extracted by mini-css-extract-plugin
export default {"mainWrapper":"style_mainWrapper__Fbu3J","contentWrapper":"style_contentWrapper__i67i6","actionsWrapper":"style_actionsWrapper__IJcgB"};